/**
 * Kennzeichnung einer optimistisch eingefügten Baumzeile (Spec 02b,
 * „Schnellerfassung · Optimistische Anzeige"). Ausschließlich der Weg über
 * „Anlegen und noch eins" erzeugt eine solche Zeile — der primäre
 * Speichern-Knopf bleibt synchron. Grund laut Spec: Eine zurückgenommene
 * Zeile braucht einen Ort für ihre Fehlermeldung, und den gibt es nur,
 * solange das Sheet offen ist.
 *
 * Ein Präfix auf der `id` statt eines eigenen Felds am `TreeNode`: Der
 * generierte Typ bleibt unverändert, und `features/objects` (liest die Zeile
 * im Baum) und `features/properties` (schreibt sie beim Anlegen) brauchen
 * keinen Import voneinander — nur diese eine geteilte Kennung aus `lib/`
 * (`apps/web/CLAUDE.md`, „Gemeinsames nach `components/` oder `lib/`").
 */

const PENDING_ENTITY_ID_PREFIX = 'pending:'

/** Eine `id`, die nie mit einer echten Server-`id` kollidiert — `crypto.randomUUID()`
 * liefert nie ein Präfix wie dieses. */
export function createPendingEntityId(): string {
  return `${PENDING_ENTITY_ID_PREFIX}${crypto.randomUUID()}`
}

export function isPendingEntityId(id: string): boolean {
  return id.startsWith(PENDING_ENTITY_ID_PREFIX)
}
